import { AppointmentRescheduleSteps } from "../index";
import { Box, Button } from "@mui/material";

interface IRescheduleDialogActionsProps {
    currentStep: AppointmentRescheduleSteps;
    handleOnCancel: () => void;
    handleOnBack: () => void;
    handleOnReschedule: () => void;
    isSaving?: boolean;
}

export default function RescheduleDialogActions({
    currentStep,
    handleOnReschedule,
    handleOnCancel,
    handleOnBack,
    isSaving,
}: IRescheduleDialogActionsProps) {
    return (
        <Box display="flex" gap="10px">
            {currentStep === AppointmentRescheduleSteps.Availability && (
                <Button
                    variant="outlined"
                    onClick={handleOnCancel}
                    disabled={isSaving}
                    data-test-id="button_reschedule_dialog_cancel"
                >
                    Cancel
                </Button>
            )}
            {currentStep === AppointmentRescheduleSteps.Confirmation && (
                <>
                    <Button
                        variant="outlined"
                        onClick={handleOnBack}
                        disabled={isSaving}
                        data-test-id="button_reschedule_dialog_back"
                    >
                        Back
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleOnReschedule}
                        disabled={isSaving}
                        data-test-id="button_reschedule_dialog_reschedule"
                    >
                        Reschedule
                    </Button>
                </>
            )}
        </Box>
    );
}
